import React, { type FunctionComponent } from 'react'
import DocumentTitle from 'legacy/components/DocumentTitle'
import AppFrame from 'legacy/components/AppFrame/AppFrame'
import { StoreGroupsEditBreadcrumbs } from 'legacy/sections/store-groups/components/breadcrumbs/components/StoreGroupsEditBreadcrumbs'
import {
  type StoreGroupsEditBodyProps,
  StoreGroupsEditBody,
} from 'legacy/sections/store-groups/components/edit/components/StoreGroupsEditBody'

interface Props extends StoreGroupsEditBodyProps {}

export const StoreGroupsEditContent: FunctionComponent<Props> = props => (
  <AppFrame data-testid="edit-store-groups">
    <DocumentTitle titleId="settings.storeGroups.title" />
    <AppFrame.Header title={<StoreGroupsEditBreadcrumbs />} />
    <AppFrame.ContentBody padding>
      <StoreGroupsEditBody {...props} />
    </AppFrame.ContentBody>
  </AppFrame>
)
